import React from "react";
import { Col, Row } from "react-bootstrap";
import classificationImage from "../../../../assets/images/knowledge2.png";
import knowledgeImage from "../../../../assets/images/knowledgeImg.png";
import RecommendedKnowledge from "./RecommendedKnowledge";
import TopClassifications from "./TopClassifications";
import TopTags from "./TopTags";
import TopViewEntity from "./TopViewEntity";

const Bam = props => {
  const handlerProps = {
    messageHandler: props.messageHandler,
    breadcrumbsHandler: props.breadcrumbsHandler
  };
  return (
    <>
      <div className="bamStatistics bam">
        <Row>
          <Col sm="12" md="6" lg="4">
            {props.recommendedKnowledge?.length ? (
              <RecommendedKnowledge
                recommendedKnowledge={props.recommendedKnowledge}
                infoWidgetImage={knowledgeImage}
                changePath={props.changePath}
              />
            ) : (
              <TopViewEntity
                {...handlerProps}
                infoWidgetImage={knowledgeImage}
              />
            )}
          </Col>
          <Col sm="12" md="6" lg="4">
            <TopTags {...handlerProps} onOccurrenceClick={props.onTagClick} />
          </Col>
          <Col sm="12" md="6" lg="4">
            <TopClassifications
              {...handlerProps}
              infoWidgetImage={classificationImage}
              onOccurrenceClick={props.onClassificationClick}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Bam;
